import { render } from "./MetricDisplaySection.vue?vue&type=template&id=5bb0a715&scoped=true"
import script from "./MetricDisplaySection.vue?vue&type=script&lang=js"
export * from "./MetricDisplaySection.vue?vue&type=script&lang=js"

import "./MetricDisplaySection.vue?vue&type=style&index=0&id=5bb0a715&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bb0a715"]])

export default __exports__